/**
 * Oleum Vitae — motor de scoring y recomendaciones (rule-based + metafields).
 */
(function (global) {
  'use strict';

  var DEFAULT_RESULTS_COUNT = 12;
  var MIN_SCORE_TO_SHOW = 12;

  var REASON_LABELS = {
    descanso_relajacion: 'Coincide con tu objetivo de descanso y relajación.',
    energia_vitalidad: 'Coincide con tu búsqueda de energía y vitalidad.',
    enfoque_claridad: 'Puede apoyar tu enfoque y claridad mental.',
    equilibrio_emocional: 'Alineado con equilibrio emocional.',
    bienestar_general: 'Opción versátil para bienestar general.',
    citrico_fresco: 'Tiene un perfil cítrico y fresco.',
    floral_suave: 'Tiene un perfil floral y suave.',
    amaderado: 'Perfil amaderado que puede gustarte.',
    herbal_mentolado: 'Notas herbales o mentoladas.',
    calido_especiado: 'Perfil cálido y especiado.',
    difusor_aroma: 'Compatible con uso en difusor o aroma.',
    piel_diluido: 'Adecuado para uso tópico diluido.',
    spray: 'Formato o uso en spray acorde a tu preferencia.',
    principiante: 'Es una opción adecuada para empezar con guía.',
    kit: 'Kit completo para facilitar tu rutina.',
    comestible: 'Apto para preparaciones comestibles.',
    dilution: 'Incluye orientación de uso responsable.',
    formato_spray: 'Producto en spray, listo para lo que buscas.',
    formato_topico: 'Formato tópico alineado con tu rutina.',
    formato_difusor: 'Ideal para difusor y crear ambiente.',
    formato_alternativa: 'Alternativa versátil si quieres ampliar opciones.'
  };

  var BENEFIT_LABELS = {
    descanso_relajacion: 'relajación y descanso',
    energia_vitalidad: 'energía y vitalidad',
    enfoque_claridad: 'enfoque y claridad',
    equilibrio_emocional: 'equilibrio emocional',
    bienestar_general: 'bienestar general',
    ambiente_relajante: 'un ambiente relajante',
    ambiente_energizante: 'un ambiente energizante',
    fresco_limpio: 'frescura y limpieza',
    calido_acogedor: 'calidez y acogimiento'
  };

  var USE_METHOD_LABELS = {
    difusor_aroma: 'difusor o aroma ambiental',
    piel_diluido: 'aplicación tópica diluida',
    spray: 'uso en spray',
    bebidas: 'preparaciones comestibles',
    formulacion: 'formulación de productos'
  };

  var USER_NEED_PHRASE = {
    difusor_aroma: 'difusor',
    piel_diluido: 'cuidado en piel',
    spray: 'uso en spray',
    bebidas: 'bebidas y cocina',
    formulacion: 'formulación propia'
  };

  var USER_BENEFIT_NEED_PHRASE = {
    descanso_relajacion: 'relajación y descanso',
    energia_vitalidad: 'energía y vitalidad',
    enfoque_claridad: 'enfoque mental',
    equilibrio_emocional: 'equilibrio emocional',
    bienestar_general: 'bienestar diario',
    ambiente_relajante: 'ambiente relajante',
    ambiente_energizante: 'ambiente con energía',
    fresco_limpio: 'frescura en el espacio',
    calido_acogedor: 'calidez en casa'
  };

  var ROLE_NEED_PHRASE = {
    topico: 'cuidado en piel',
    portador: 'mezclas tópicas diluidas',
    puro: 'aromaterapia en difusor',
    mezcla: 'aroma ambiental',
    spray: 'frescura al instante',
    kit: 'rutina completa',
    combo: 'probar varios formatos'
  };

  var USE_METHOD_EXPLANATION = {
    difusor_aroma: {
      puro: 'es un aceite puro que aromatiza bien en difusor',
      mezcla: 'es una mezcla lista para usar en difusor',
      kit: 'incluye esencias para aromatizar en difusor',
      spray: 'refresca el ambiente y puede complementar tu difusor',
      otro: 'aromatiza el espacio cuando lo usas en difusor'
    },
    spray: {
      spray: 'viene en spray listo para rociar',
      puro: 'puedes diluirlo para preparar tu spray',
      kit: 'incluye opciones prácticas en formato spray',
      otro: 'se adapta bien a aplicación en spray'
    },
    piel_diluido: {
      topico: 'es un producto corporal pensado para la rutina de piel',
      puro: 'concentrado ideal para mezclas tópicas diluidas',
      portador: 'funciona como aceite portador para diluir en piel',
      kit: 'reúne formatos para cuidado corporal diluido',
      otro: 'encaja con uso tópico diluido responsable'
    },
    bebidas: {
      otro: 'es apto para enriquecer bebidas y preparaciones comestibles'
    },
    formulacion: {
      puro: 'concentra la esencia para tus mezclas',
      portador: 'es una base neutra para formulaciones',
      otro: 'funciona bien en formulación casera'
    }
  };

  function asList(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(String);
    if (typeof val === 'string') {
      if (val.indexOf('|') !== -1) return val.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (val.indexOf(',') !== -1) return val.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      try {
        var parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch (e) {}
      return val.trim() ? [val.trim()] : [];
    }
    return [];
  }

  var AROMA_PURO_HANDLES = ['citricos', 'herbales', 'especias', 'amaderados', 'florales', 'argan', 'moringa'];

  var COLLECTION_SCOPE_BY_HANDLE = {
    'aceites-esenciales-puros': {
      allowKinds: ['aceite_puro'],
      denyKinds: ['kit', 'kit_aceites', 'kit_sprays', 'kit_skincare', 'mezcla', 'portador', 'skincare', 'spray', 'desinfectante', 'aplicador']
    },
    mezclas: { allowKinds: ['mezcla'] },
    portadores: { allowKinds: ['portador'] },
    'aceites-esenciales': {
      allowKinds: ['aceite_puro', 'mezcla', 'portador', 'kit_aceites', 'kit']
    },
    'aceites-esenciales-todos': {
      allowKinds: ['aceite_puro', 'mezcla', 'portador', 'kit_aceites', 'kit']
    },
    kits: { allowKinds: ['kit', 'kit_aceites', 'kit_sprays', 'kit_skincare'] },
    'kits-de-aceites': { allowKinds: ['kit_aceites', 'kit'], requireAnyTag: ['kits-de-aceites', 'kit-aceites'] },
    'kits-de-sprays-estimulantes': { allowKinds: ['kit_sprays', 'spray'] },
    'sprays-estimulantes': { allowKinds: ['spray'] },
    desinfectantes: { allowKinds: ['desinfectante'] },
    'skincare-y-belleza': { allowKinds: ['skincare', 'kit_skincare'] }
  };

  AROMA_PURO_HANDLES.forEach(function (handle) {
    COLLECTION_SCOPE_BY_HANDLE[handle] = {
      allowKinds: ['aceite_puro'],
      requireTag: handle
    };
  });

  function normalizeProduct(raw) {
    if (!raw) return null;
    return {
      id: raw.id,
      handle: raw.handle,
      sku: raw.sku || '',
      title: raw.title,
      url: raw.url,
      image: raw.image,
      price: raw.price,
      available: raw.available !== false && raw.available !== 'false',
      tags: asList(raw.tags),
      roles: asList(raw.oleum_roles),
      profiles: asList(raw.oleum_profiles),
      intents: asList(raw.oleum_intents),
      benefits: asList(raw.oleum_benefits),
      aromas: asList(raw.oleum_aromas),
      use_methods: asList(raw.oleum_use_methods),
      experience_levels: asList(raw.oleum_experience_levels),
      is_edible: raw.oleum_is_edible === true || raw.oleum_is_edible === 'true',
      is_kit: raw.oleum_is_kit === true || raw.oleum_is_kit === 'true',
      safety_notes: raw.oleum_safety_notes || '',
      priority: parseInt(raw.oleum_recommendation_priority, 10) || 50,
      routes: asList(raw.oleum_recommended_routes),
      extracto: raw.oleum_extracto || '',
      ingrediente: raw.oleum_ingrediente || '',
      beneficios_text: raw.oleum_beneficios_text || ''
    };
  }

  function hasMatch(list, value) {
    if (!value || !list || !list.length) return false;
    return list.indexOf(value) !== -1;
  }

  function productSku(product) {
    return String((product && product.sku) || '').toUpperCase();
  }

  function productHasCollectionTag(product, handle) {
    var needle = String(handle || '').toLowerCase();
    if (!needle) return false;
    return (product.tags || []).some(function (tag) {
      return String(tag).toLowerCase() === needle;
    });
  }

  function getBrowseCollectionHandle(ctx) {
    if (!ctx) return '';
    return String(ctx.browse_collection || ctx.ov_collection || '').trim();
  }

  function normalizeCollectionHandle(raw) {
    var h = String(raw || '').toLowerCase().trim();
    if (!h) return '';
    if (COLLECTION_SCOPE_BY_HANDLE[h]) return h;

    var i;
    for (i = 0; i < AROMA_PURO_HANDLES.length; i++) {
      if (h.indexOf(AROMA_PURO_HANDLES[i]) !== -1) return AROMA_PURO_HANDLES[i];
    }
    if (h.indexOf('aceites-esenciales-puros') !== -1) return 'aceites-esenciales-puros';
    if (h.indexOf('aceites-esenciales-todos') !== -1) return 'aceites-esenciales-todos';
    if (h === 'aceites-esenciales' || h.indexOf('aceites-esenciales-aceites') === 0) {
      return 'aceites-esenciales';
    }
    if (h.indexOf('kits-de-aceites') !== -1) return 'kits-de-aceites';
    if (h.indexOf('kits-de-sprays') !== -1) return 'kits-de-sprays-estimulantes';
    if (h.indexOf('mezclas') !== -1 && h.indexOf('kit') === -1) return 'mezclas';
    if (h.indexOf('portadores') !== -1) return 'portadores';
    if (h.indexOf('sprays-estimulantes') !== -1) return 'sprays-estimulantes';
    if (h.indexOf('desinfectantes') !== -1 && h.indexOf('kit') === -1) return 'desinfectantes';
    if (h.indexOf('skincare') !== -1 && h.indexOf('kit') === -1) return 'skincare-y-belleza';
    if (h.indexOf('kits') === 0 || h.indexOf('-kits') !== -1 || h.indexOf('kits-') !== -1) return 'kits';
    return h;
  }

  function shouldApplyCollectionScope(ctx) {
    var scopeKey = normalizeCollectionHandle(getBrowseCollectionHandle(ctx));
    return !!(scopeKey && COLLECTION_SCOPE_BY_HANDLE[scopeKey]);
  }

  function inferProductKind(product) {
    var sku = productSku(product);
    if (/^AES-P-/.test(sku)) return 'aceite_puro';
    if (/^AES-M-/.test(sku)) return 'mezcla';
    if (/^AES-C-/.test(sku)) return 'portador';
    if (/^(AES-K|AES-KIT|OLE-KIT)/.test(sku)) return 'kit_aceites';
    if (/^IDE-KIT-STIM|^IDE-K-STIM/.test(sku)) return 'kit_sprays';
    if (/^IDE-K-CDP|^IDE-KIT-SKIN|^IDE-K-OILS|^IDE-K-MIST|^IDE-KIT-/.test(sku)) return 'kit_skincare';
    if (/^IDE-STIM-/.test(sku)) return 'spray';
    if (/^IDE-DESIN-/.test(sku)) return 'desinfectante';
    if (/^IDE-(BL|BM|BO|SG|TF)-/.test(sku)) return 'skincare';
    if (/^TEC-|^ZHN-|^NJE-/.test(sku)) return 'aplicador';

    var fmt = detectProductFormat(product);
    if (product.is_kit || fmt === 'kit') {
      var title = String(product.title || '').toLowerCase();
      if (title.indexOf('spray') !== -1) return 'kit_sprays';
      if (title.indexOf('skincare') !== -1 || title.indexOf('cuidado de la piel') !== -1) {
        return 'kit_skincare';
      }
      return 'kit_aceites';
    }
    if (fmt === 'aceite_puro') return 'aceite_puro';
    if (fmt === 'mezcla') return 'mezcla';
    if (fmt === 'portador') return 'portador';
    if (fmt === 'spray') return 'spray';
    if (fmt === 'topico') return 'skincare';
    return fmt || 'otro';
  }

  function productMatchesCollectionScope(product, scopeKey) {
    if (!scopeKey) return true;
    var rules = COLLECTION_SCOPE_BY_HANDLE[scopeKey];
    if (!rules) return true;

    var kind = inferProductKind(product);
    if (rules.denyKinds && rules.denyKinds.indexOf(kind) !== -1) return false;
    if (rules.allowKinds && rules.allowKinds.length && rules.allowKinds.indexOf(kind) === -1) {
      return false;
    }
    if (rules.requireTag && !productHasCollectionTag(product, rules.requireTag)) return false;
    if (rules.requireAnyTag && rules.requireAnyTag.length) {
      var tagged = rules.requireAnyTag.some(function (tag) {
        return productHasCollectionTag(product, tag);
      });
      if (!tagged) return false;
    }
    return true;
  }

  function detectProductFormat(product) {
    var sku = productSku(product);
    if (/^AES-P-/.test(sku)) return 'aceite_puro';
    if (/^AES-M-/.test(sku)) return 'mezcla';
    if (/^AES-C-/.test(sku)) return 'portador';
    if (/^(AES-K|AES-KIT|OLE-KIT)/.test(sku)) return 'kit';

    var title = String(product.title || '').toLowerCase();
    var tags = (product.tags || []).join(' ').toLowerCase();
    var blob = title + ' ' + tags;

    if (product.is_kit || blob.indexOf('kit') !== -1) return 'kit';
    if (blob.indexOf('spray') !== -1 || hasMatch(product.use_methods, 'spray')) return 'spray';
    if (blob.indexOf('gel de ducha') !== -1 || blob.indexOf('shower gel') !== -1) return 'topico';
    if (blob.indexOf('crema') !== -1 || blob.indexOf('lotion') !== -1 || blob.indexOf('body mist') !== -1) {
      return 'topico';
    }
    if (blob.indexOf('mezcla') !== -1) return 'mezcla';
    if (
      blob.indexOf('aceite esencial puro') !== -1 ||
      blob.indexOf('aceite esencial de') !== -1 ||
      (blob.indexOf('aceite esencial') !== -1 && blob.indexOf('conductor') === -1)
    ) {
      return 'aceite_puro';
    }
    if (blob.indexOf('portador') !== -1 || blob.indexOf('conductor') !== -1 || blob.indexOf('fraccionado') !== -1) {
      return 'portador';
    }
    return 'otro';
  }

  var OLEUM_BENEFIT_PHRASE = {
    descanso_relajacion: 'está orientado a calma, pausa y descanso',
    energia_vitalidad: 'ayuda a despertar sensación de energía y movimiento',
    enfoque_claridad: 'apoya momentos de concentración y claridad mental',
    equilibrio_emocional: 'acompaña el equilibrio emocional y la serenidad',
    bienestar_general: 'es versátil para bienestar cotidiano',
    cuidado_piel: 'cuida e hidrata la piel en rutina diaria',
    relajacion: 'favorece momentos de relajación sensorial',
    descanso: 'pensado para acompañar el descanso'
  };

  var INTENT_PHRASE = {
    bienestar_personal: 'encaja con bienestar personal y autocuidado',
    skincare: 'integra aroma y cuidado en tu rutina de piel',
    bienestar_corporal: 'acompaña el bienestar corporal en movimiento o reposo',
    hogar_espacios: 'transforma el ambiente de tu hogar o espacio',
    gastronomia_bebidas: 'apto para enriquecer preparaciones comestibles'
  };

  var AROMA_PHRASE = {
    citrico_fresco: 'su aroma cítrico y fresco va bien con tu búsqueda',
    floral_suave: 'tiene un perfil floral suave afín a lo que buscas',
    herbal_mentolado: 'aporta notas herbales o mentoladas similares a tu preferencia',
    amaderado: 'su fondo amaderado conecta con el perfil que buscas',
    calido_especiado: 'su matiz cálido y especiado encaja con tu preferencia'
  };

  var INGREDIENT_HELP = {
    lavanda: {
      descanso_relajacion: 'la lavanda se asocia tradicionalmente con calma y preparar el descanso',
      equilibrio_emocional: 'su aroma floral suave ayuda a serenar el ánimo',
      default: 'notas de lavanda floral y relajante'
    },
    geranio: {
      descanso_relajacion: 'el geranio aporta dulzura floral reconfortante',
      equilibrio_emocional: 'aroma floral equilibrado y envolvente',
      default: 'geranio floral y suave'
    },
    menta: {
      energia_vitalidad: 'la menta aporta frescura revitalizante al instante',
      enfoque_claridad: 'su frescura herbal despeja y activa',
      descanso_relajacion: 'frescura herbal que alivia la tensión del día',
      default: 'menta fresca y vigorizante'
    },
    romero: {
      enfoque_claridad: 'el romero tiene perfil herbal que despeja y enfoca',
      energia_vitalidad: 'notas herbales estimulantes',
      default: 'romero herbal intenso'
    },
    incienso: {
      descanso_relajacion: 'incienso amaderado para momentos de introspección y calma',
      equilibrio_emocional: 'aroma profundo que invita a pausar',
      default: 'incienso amaderado y meditativo'
    },
    mandarina: {
      energia_vitalidad: 'mandarina cítrica que ilumina y alegra el ánimo',
      bienestar_general: 'cítrico dulce para bienestar diario',
      default: 'mandarina alegre y luminosa'
    },
    naranja: {
      energia_vitalidad: 'naranja cítrica que aporta frescura y ánimo',
      bienestar_general: 'cítrico cálido y accesible',
      default: 'naranja dulce y solar'
    },
    toronja: {
      energia_vitalidad: 'toronja vibrante que despierta los sentidos',
      default: 'toronja cítrica energizante'
    },
    bergamota: {
      equilibrio_emocional: 'bergamota cítrica y floral que equilibra el ánimo',
      descanso_relajacion: 'cítrico suave que relaja sin pesar',
      default: 'bergamota fresca y elegante'
    },
    eucalipto: {
      enfoque_claridad: 'eucalipto herbal que despeja y abre la respiración',
      energia_vitalidad: 'frescura mentolada revitalizante',
      default: 'eucalipto limpio y vigorizante'
    },
    jazmin: {
      equilibrio_emocional: 'jazmín floral delicado y envolvente',
      descanso_relajacion: 'floral suave para momentos íntimos de calma',
      default: 'jazmín floral elegante'
    },
    rosa: {
      equilibrio_emocional: 'rosa delicada que acompaña el cuidado personal',
      descanso_relajacion: 'floral suave y reconfortante',
      default: 'rosa floral y gentil'
    },
    sandalo: {
      descanso_relajacion: 'sándalo cálido y profundo para ralentizar el ritmo',
      equilibrio_emocional: 'amaderado suave que reconforta',
      default: 'sándalo amaderado y sereno'
    },
    limon: {
      energia_vitalidad: 'limón cítrico que aclara y activa',
      default: 'limón fresco y limpio'
    },
    limón: {
      energia_vitalidad: 'limón cítrico que aclara y activa',
      default: 'limón fresco y limpio'
    }
  };

  function normalizeIngredientKey(name) {
    return String(name || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function resolveIngredient(product) {
    if (product.ingrediente) return String(product.ingrediente).trim();
    return extractIngredientHint(product);
  }

  function firstSentence(text, maxLen) {
    var t = String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!t) return '';
    var parts = t.split(/(?<=[.!?])\s+/);
    t = parts[0] || t;
    if (t.length > maxLen) t = t.substring(0, maxLen - 1) + '…';
    return t;
  }

  function firstBeneficioLine(text) {
    var line = String(text || '')
      .split(/\n/)
      .map(function (s) {
        return s.replace(/^[\s\-•*]+/, '').trim();
      })
      .filter(Boolean)[0];
    return line || '';
  }

  function parseComboPieces(title) {
    var t = String(title || '').toLowerCase();
    var parts = [];
    if (t.indexOf('body lotion') !== -1 || (t.indexOf('lotion') !== -1 && t.indexOf('body') !== -1)) {
      parts.push('crema corporal');
    }
    if (t.indexOf('body mist') !== -1 || (t.indexOf('mist') !== -1 && t.indexOf('body') !== -1)) {
      parts.push('body mist');
    }
    if (t.indexOf('shower gel') !== -1 || t.indexOf('gel de ducha') !== -1) {
      parts.push('gel de ducha');
    }
    if (t.indexOf('hair and body') !== -1 || t.indexOf('cabello y cuerpo') !== -1) {
      parts.push('aceite para cabello y cuerpo');
    }
    if (t.indexOf('shower gel') === -1 && t.indexOf('gel') !== -1 && parts.indexOf('gel de ducha') === -1) {
      parts.push('gel');
    }
    return parts;
  }

  function extractSprayPurpose(title) {
    var t = String(title || '').toLowerCase();
    if (t.indexOf('rest') !== -1 && t.indexOf('fresh feet') === -1) {
      return 'formulado para apoyar descanso y relajación';
    }
    if (t.indexOf('inspire') !== -1) return 'orientado a vías respiratorias y sensación de apertura';
    if (t.indexOf('muscle') !== -1 || t.indexOf('muscular') !== -1) {
      return 'pensado para masaje muscular y aliviar tensión corporal';
    }
    if (t.indexOf('fresh feet') !== -1 || t.indexOf('pies') !== -1) {
      return 'refresca pies cansados al final del día';
    }
    if (t.indexOf('desinfectante') !== -1) return 'higiene de manos y superficies con aroma funcional';
    return '';
  }

  function extractMezclaName(title) {
    var m = String(title || '').match(/["“]([^"”]+)["”]/);
    if (m) return m[1];
    var lower = String(title || '').toLowerCase();
    var names = ['relax', 'balance', 'digest', 'breathe', 'energy', 'protect', 'relief'];
    for (var i = 0; i < names.length; i++) {
      if (lower.indexOf(names[i]) !== -1) {
        return names[i].charAt(0).toUpperCase() + names[i].slice(1);
      }
    }
    return '';
  }

  function extractComboFormatHint(title, ingredient) {
    var pieces = parseComboPieces(title);
    if (pieces.length >= 2) {
      return 'Incluye ' + pieces.slice(0, 3).join(' y ');
    }
    var lower = String(title || '').toLowerCase();
    var hints = [];
    if (lower.indexOf('lotion') !== -1 || lower.indexOf('crema') !== -1) hints.push('crema corporal');
    if (lower.indexOf('gel') !== -1) hints.push('gel de ducha');
    if (lower.indexOf('mist') !== -1) hints.push('body mist');
    if (lower.indexOf('spray') !== -1) hints.push('spray');
    if (lower.indexOf('aceite') !== -1) hints.push('aceite esencial');
    if (hints.length >= 2) return 'Combina ' + hints.join(' y ') + ' en una sola compra';
    if (hints.length === 1 && ingredient) {
      return 'Pack con ' + hints[0] + ' de ' + String(ingredient).toLowerCase();
    }
    return '';
  }

  function hashSeed(str) {
    var h = 0;
    var s = String(str || '');
    for (var i = 0; i < s.length; i++) {
      h = ((h << 5) - h) + s.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h);
  }

  var ROLE_FALLBACKS = {
    spray: [
      'es práctico de rociar y llevar contigo',
      'viene listo para usar sin preparar mezclas',
      'te permite refrescarte en segundos'
    ],
    puro: [
      'aromatiza muy bien con pocas gotas en difusor',
      'concentra el aroma que buscas para tu rutina',
      'es versátil para difusor, inhalación o mezclas diluidas'
    ],
    kit: [
      'reúne varios productos coordinados para empezar sin complicarte',
      'te arma una rutina completa en una sola compra',
      'incluye lo esencial para no armar todo desde cero'
    ],
    mezcla: [
      'ya viene balanceada, sin adivinar proporciones',
      'tiene un perfil aromático definido listo para usar',
      'combina esencias que funcionan bien juntas'
    ],
    topico: [
      'integra aroma y cuidado en tu rutina diaria',
      'es un formato corporal fácil de usar cada día',
      'combina bienestar sensorial con cuidado de piel'
    ],
    combo: [
      'te deja probar varios formatos en una sola compra',
      'combina presentaciones para comparar texturas y usos',
      'ofrece buena relación de valor entre formatos'
    ],
    portador: [
      'sirve como base neutra para diluir esencias con seguridad',
      'es ideal para mezclas tópicas en casa',
      'facilita aplicar aceites esenciales de forma responsable'
    ],
    otro: [
      'encaja con lo que buscas en aroma y uso',
      'combina bien con tu perfil de preferencias',
      'es una opción coherente con tu búsqueda'
    ]
  };

  function normalizePhraseKey(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .substring(0, 72);
  }

  function phraseAlreadyUsed(text, usedKeys) {
    var key = normalizePhraseKey(text);
    if (!key) return true;
    if (usedKeys[key]) return true;
    return false;
  }

  function markPhraseUsed(text, usedKeys) {
    var key = normalizePhraseKey(text);
    if (key) usedKeys[key] = true;
  }

  function phraseOverlapScore(a, b) {
    var wa = normalizePhraseKey(a).split(' ').filter(function (w) {
      return w.length > 3;
    });
    var wb = normalizePhraseKey(b).split(' ').filter(function (w) {
      return w.length > 3;
    });
    var overlap = 0;
    wa.forEach(function (w) {
      if (wb.indexOf(w) !== -1) overlap += 1;
    });
    return overlap;
  }

  function phrasesTooSimilar(a, b) {
    if (!a || !b) return false;
    var ka = normalizePhraseKey(a);
    var kb = normalizePhraseKey(b);
    if (!ka || !kb) return false;
    if (ka === kb) return true;
    if (ka.indexOf('kit') !== -1 && kb.indexOf('kit') !== -1) return true;
    if (ka.indexOf('difusor') !== -1 && kb.indexOf('difusor') !== -1) return true;
    return phraseOverlapScore(a, b) >= 2;
  }

  function productBlob(product) {
    return (
      String(product.title || '') +
      ' ' +
      (product.tags || []).join(' ') +
      ' ' +
      String(product.extracto || '')
    ).toLowerCase();
  }

  function productSupportsUserMethod(product, role, format, method) {
    if (!method || method === 'no_seguro') return false;
    if (hasMatch(product.use_methods, method)) return true;
    var blob = productBlob(product);
    if (method === 'difusor_aroma') {
      if (role === 'combo') {
        return (
          blob.indexOf('aceite esencial') !== -1 ||
          blob.indexOf('aceite puro') !== -1 ||
          blob.indexOf('mezcla') !== -1 ||
          blob.indexOf('difusor') !== -1
        );
      }
      return (
        role === 'puro' ||
        role === 'mezcla' ||
        format === 'aceite_puro' ||
        format === 'mezcla' ||
        role === 'kit' ||
        role === 'spray'
      );
    }
    if (method === 'spray') {
      return role === 'spray' || format === 'spray' || role === 'puro';
    }
    if (method === 'piel_diluido') {
      return role === 'topico' || role === 'portador' || role === 'puro' || role === 'kit';
    }
    if (method === 'bebidas') {
      return product.is_edible || productBlob(product).indexOf('comest') !== -1;
    }
    if (method === 'formulacion') {
      return role === 'puro' || role === 'portador' || role === 'mezcla';
    }
    return false;
  }

  function describeKitForMethod(product, method) {
    var blob = productBlob(product);
    if (method === 'difusor_aroma') {
      if (blob.indexOf('difusor') !== -1) return 'Incluye difusor para aromatizar al instante.';
      if (blob.indexOf('mezcla') !== -1) return 'Trae mezclas listas para tu difusor.';
      if (blob.indexOf('aceite esencial') !== -1 || blob.indexOf('aceite puro') !== -1) {
        return 'Incluye aceites esenciales para usar en difusor.';
      }
    }
    if (method === 'spray' && blob.indexOf('spray') !== -1) {
      return 'Incluye spray listo para aplicar.';
    }
    if (method === 'piel_diluido') {
      var pieces = parseComboPieces(product.title);
      if (pieces.length) return 'Rutina corporal: ' + pieces.join(', ') + '.';
    }
    return '';
  }

  function buildUserNeedPhrase(userContext) {
    var method = userContext.use_method;
    if (method && method !== 'no_seguro' && USER_NEED_PHRASE[method]) {
      return USER_NEED_PHRASE[method];
    }
    if (userContext.benefit && USER_BENEFIT_NEED_PHRASE[userContext.benefit]) {
      return USER_BENEFIT_NEED_PHRASE[userContext.benefit];
    }
    return '';
  }

  function buildExplanationNeed(product, userContext, role, format) {
    var method = userContext.use_method;
    if (method && method !== 'no_seguro' && productSupportsUserMethod(product, role, format, method)) {
      if (USER_NEED_PHRASE[method]) return USER_NEED_PHRASE[method];
    }
    if (userContext.benefit && USER_BENEFIT_NEED_PHRASE[userContext.benefit]) {
      return USER_BENEFIT_NEED_PHRASE[userContext.benefit];
    }
    if (ROLE_NEED_PHRASE[role]) return ROLE_NEED_PHRASE[role];
    return '';
  }

  function getBucketOrderForContext(userContext) {
    var scopeKey = normalizeCollectionHandle(getBrowseCollectionHandle(userContext));
    if (scopeKey === 'aceites-esenciales-puros' || AROMA_PURO_HANDLES.indexOf(scopeKey) !== -1) {
      return ['puro'];
    }
    if (scopeKey === 'mezclas') return ['mezcla'];
    if (scopeKey === 'portadores') return ['portador'];
    if (scopeKey === 'sprays-estimulantes') return ['spray'];
    if (scopeKey === 'kits-de-aceites' || scopeKey === 'kits') return ['kit'];
    if (scopeKey === 'kits-de-sprays-estimulantes') return ['spray', 'kit'];

    var method = userContext && userContext.use_method;
    if (!method || method === 'no_seguro') {
      return ['spray', 'puro', 'kit', 'mezcla', 'topico', 'combo', 'portador', 'otro'];
    }
    if (method === 'difusor_aroma') {
      return ['puro', 'mezcla', 'kit', 'spray', 'combo'];
    }
    if (method === 'piel_diluido') {
      return ['topico', 'portador', 'puro', 'kit', 'combo', 'mezcla'];
    }
    if (method === 'spray') {
      return ['spray', 'puro', 'kit', 'combo', 'mezcla'];
    }
    if (method === 'bebidas') {
      return ['puro', 'otro'];
    }
    if (method === 'formulacion') {
      return ['puro', 'portador', 'mezcla'];
    }
    return ['spray', 'puro', 'kit', 'mezcla', 'topico', 'combo', 'portador', 'otro'];
  }

  function filterRankedByUseMethod(ranked, userContext) {
    var method = userContext && userContext.use_method;
    if (!method || method === 'no_seguro') return ranked;
    var compatible = (ranked || []).filter(function (row) {
      if (!row || !row.product) return false;
      var fmt = row.format || detectProductFormat(row.product);
      var role = row.role || detectProductRole(row.product, fmt);
      return productSupportsUserMethod(row.product, role, fmt, method);
    });
    return compatible.length ? compatible : ranked;
  }

  function normalizeWhyClause(text) {
    return String(text || '')
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/^porque\s+/i, '')
      .replace(/\.$/, '')
      .replace(/:\s*([a-z])/gi, function (_match, next) {
        return ', ' + next;
      })
      .replace(/\s+,/g, ',');
  }

  function productExplanationKey(product, suffix) {
    return String(suffix || '') + ':' + (product.handle || product.id || 'item');
  }

  function composeExplanation(need, why) {
    why = normalizeWhyClause(why);
    if (!why) return '';
    var whyLower = why.charAt(0).toLowerCase() + why.slice(1);
    if (need) {
      return 'Para ' + need + ', te lo recomendamos porque ' + whyLower + '.';
    }
    return 'Te lo recomendamos porque ' + whyLower + '.';
  }

  function getUseMethodCandidate(product, userContext, role, format) {
    var method = userContext.use_method;
    if (!method || method === 'no_seguro') return null;
    if (!productSupportsUserMethod(product, role, format, method)) return null;

    var text = '';
    if (role === 'kit' || product.is_kit) {
      text = describeKitForMethod(product, method);
    }
    if (!text) {
      var bucket = USE_METHOD_EXPLANATION[method] || {};
      text = bucket[role] || bucket[format] || bucket.otro || '';
    }
    if (!text) return null;

    return {
      text: normalizeWhyClause(text),
      weight: 98,
      key: productExplanationKey(product, 'use-method:' + method + ':' + role)
    };
  }

  function pickVariedLine(list, seed) {
    if (!list || !list.length) return '';
    var n = parseInt(seed, 10);
    if (isNaN(n)) n = 0;
    return list[Math.abs(n) % list.length];
  }

  function capitalizeSentence(text) {
    var t = String(text || '').trim();
    if (!t) return '';
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function collectExplanationCandidates(product, userContext, ingredient, role, format) {
    var benefit = userContext.benefit;
    var method = userContext.use_method;
    var candidates = [];
    var beneficioLine = firstBeneficioLine(product.beneficios_text);
    var ingKey = normalizeIngredientKey(ingredient);
    var comboPieces = parseComboPieces(product.title);
    var mezcla = extractMezclaName(product.title);
    var sprayPurpose = extractSprayPurpose(product.title);
    var useMethodCandidate = getUseMethodCandidate(product, userContext, role, format);
    var i;

    if (useMethodCandidate) {
      candidates.push(useMethodCandidate);
    }

    if (beneficioLine) {
      candidates.push({
        text: normalizeWhyClause(beneficioLine),
        weight: 100,
        key: productExplanationKey(product, 'beneficio:' + normalizePhraseKey(beneficioLine))
      });
    }

    if (product.extracto) {
      var extracto = firstSentence(product.extracto, 160);
      if (extracto) {
        candidates.push({
          text: normalizeWhyClause(extracto),
          weight: 96,
          key: productExplanationKey(product, 'extracto:' + normalizePhraseKey(extracto))
        });
      }
    }

    if (ingKey && INGREDIENT_HELP[ingKey]) {
      var ingPhrase = INGREDIENT_HELP[ingKey][benefit] || INGREDIENT_HELP[ingKey].default;
      candidates.push({
        text: normalizeWhyClause(ingPhrase),
        weight: 92,
        key: productExplanationKey(product, 'ing:' + ingKey + ':' + benefit)
      });
    }

    if (role === 'spray' && sprayPurpose) {
      candidates.push({
        text: normalizeWhyClause(sprayPurpose),
        weight: 88,
        key: productExplanationKey(product, 'spray:' + normalizePhraseKey(sprayPurpose))
      });
    }

    if ((role === 'kit' || role === 'combo') && comboPieces.length) {
      candidates.push({
        text: 'incluye ' + comboPieces.join(', '),
        weight: 86,
        key: productExplanationKey(product, 'combo:' + comboPieces.join('+'))
      });
    } else if (role === 'combo') {
      var comboHint = extractComboFormatHint(product.title, ingredient);
      if (comboHint) {
        candidates.push({
          text: normalizeWhyClause(comboHint),
          weight: 89,
          key: productExplanationKey(product, 'combo-hint')
        });
      }
    }

    if (role === 'mezcla') {
      if (mezcla) {
        candidates.push({
          text: 'la mezcla "' + mezcla + '" ya tiene un objetivo aromático claro',
          weight: 84,
          key: productExplanationKey(product, 'mezcla:' + mezcla.toLowerCase())
        });
      } else {
        candidates.push({
          text: 'combina esencias que ya vienen balanceadas',
          weight: 80,
          key: productExplanationKey(product, 'mezcla:generic')
        });
      }
    }

    if (role === 'topico') {
      candidates.push({
        text: 'es un ' + topicoKind(product.title) + ' fácil de integrar en tu rutina',
        weight: 78,
        key: productExplanationKey(product, 'topico')
      });
    }

    for (i = 0; i < (product.benefits || []).length; i++) {
      if (OLEUM_BENEFIT_PHRASE[product.benefits[i]]) {
        candidates.push({
        text: normalizeWhyClause(OLEUM_BENEFIT_PHRASE[product.benefits[i]]),
        weight: 68,
        key: productExplanationKey(product, 'benefit:' + product.benefits[i])
      });
        break;
      }
    }

    if (
      userContext.aroma &&
      userContext.aroma !== 'sin_preferencia' &&
      hasMatch(product.aromas, userContext.aroma) &&
      AROMA_PHRASE[userContext.aroma]
    ) {
      candidates.push({
        text: normalizeWhyClause(AROMA_PHRASE[userContext.aroma]),
        weight: 64,
        key: productExplanationKey(product, 'aroma:' + userContext.aroma)
      });
    }

    if (hasMatch(product.intents, userContext.intent) && INTENT_PHRASE[userContext.intent]) {
      candidates.push({
        text: normalizeWhyClause(INTENT_PHRASE[userContext.intent]),
        weight: 62,
        key: productExplanationKey(product, 'intent:' + userContext.intent)
      });
    }

    if (role === 'spray' && method === 'difusor_aroma' && !useMethodCandidate) {
      candidates.push({
        text: 'funciona como alternativa práctica si no usas difusor',
        weight: 56,
        key: productExplanationKey(product, 'spray:no-difusor')
      });
    }

    candidates.sort(function (a, b) {
      return b.weight - a.weight;
    });

    return candidates;
  }

  function buildProductExplanation(product, userContext, format, usedKeys) {
    usedKeys = usedKeys || {};
    var ingredient = resolveIngredient(product);
    var role = detectProductRole(product, format);
    var candidates = collectExplanationCandidates(product, userContext, ingredient, role, format);
    var need = buildExplanationNeed(product, userContext, role, format);
    var why = '';
    var i;

    for (i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (!candidate.text) continue;
      if (phraseAlreadyUsed(candidate.text, usedKeys)) continue;
      if (candidate.key && usedKeys['__key:' + candidate.key]) continue;
      why = candidate.text;
      markPhraseUsed(why, usedKeys);
      if (candidate.key) usedKeys['__key:' + candidate.key] = true;
      break;
    }

    if (!why) {
      var emptyFallbackBucket = ROLE_FALLBACKS[role] || ROLE_FALLBACKS[format] || ROLE_FALLBACKS.otro;
      why = normalizeWhyClause(
        pickVariedLine(emptyFallbackBucket, hashSeed((product.handle || '') + ':' + product.id + ':' + role))
      );
    }

    var out = composeExplanation(need, why);
    if (out.length > 520) {
      out = out.substring(0, 517).replace(/\s+[^\s]*$/, '') + '…';
    }
    return out;
  }
  function extractIngredientHint(product) {
    var title = String(product.title || '').toLowerCase();
    var hints = [
      'lavanda',
      'geranio',
      'menta',
      'romero',
      'incienso',
      'jazmín',
      'jazmin',
      'mandarina',
      'eucalipto',
      'naranja',
      'toronja',
      'bergamota',
      'rosa',
      'sándalo',
      'sandalo',
      'limón',
      'limon',
      'orégano',
      'oregano',
      'cedro'
    ];
    for (var i = 0; i < hints.length; i++) {
      if (title.indexOf(hints[i]) !== -1) {
        return hints[i].charAt(0).toUpperCase() + hints[i].slice(1);
      }
    }
    return '';
  }

  function detectProductRole(product, format) {
    var title = String(product.title || '').toLowerCase();
    if (
      title.indexOf('combo') !== -1 ||
      title.indexOf('3x2') !== -1 ||
      title.indexOf('duo') !== -1 ||
      title.indexOf('promo') !== -1
    ) {
      return 'combo';
    }
    if (format === 'kit') return 'kit';
    if (format === 'aceite_puro') return 'puro';
    if (format === 'mezcla') return 'mezcla';
    if (format === 'spray') return 'spray';
    if (format === 'topico') return 'topico';
    if (format === 'portador') return 'portador';
    return 'otro';
  }

  function topicoKind(title) {
    var t = String(title || '').toLowerCase();
    if (t.indexOf('gel') !== -1) return 'gel de ducha';
    if (t.indexOf('crema') !== -1 || t.indexOf('lotion') !== -1) return 'crema corporal';
    if (t.indexOf('mist') !== -1) return 'body mist';
    if (t.indexOf('fragancia') !== -1) return 'fragancia corporal';
    if (t.indexOf('aceite para cabello') !== -1) return 'aceite para cabello y cuerpo';
    return 'producto corporal';
  }

  function diversifySelection(ranked, totalCount, userContext) {
    if (!ranked.length || totalCount <= 0) return [];

    var picked = [];
    var usedIds = {};
    var byBucket = {};

    ranked.forEach(function (row) {
      if (!row || !row.product) return;
      var fmt = row.format || detectProductFormat(row.product);
      var bucket = detectProductRole(row.product, fmt);
      if (bucket === 'otro') bucket = fmt || 'otro';
      if (!byBucket[bucket]) byBucket[bucket] = [];
      byBucket[bucket].push(row);
    });

    var bucketOrder = getBucketOrderForContext(userContext);
    bucketOrder.forEach(function (bucket) {
      if (picked.length >= totalCount) return;
      var list = byBucket[bucket];
      if (!list || !list.length) return;
      var row = list[0];
      if (usedIds[row.product.id]) return;
      usedIds[row.product.id] = true;
      picked.push(row);
    });

    ranked.forEach(function (row) {
      if (picked.length >= totalCount) return;
      if (!row || !row.product || usedIds[row.product.id]) return;
      usedIds[row.product.id] = true;
      picked.push(row);
    });

    return picked;
  }

  /**
   * @param {object} product
   * @param {object} userContext
   * @returns {{product: object, score: number, reasons: string[]}}
   */
  function scoreProduct(product, userContext) {
    product = normalizeProduct(product);
    userContext = userContext || {};
    var reasons = [];
    var score = 0;

    if (!product || !product.available) {
      return { product: product, score: -9999, reasons: ['Sin disponibilidad.'] };
    }

    if (shouldApplyCollectionScope(userContext)) {
      var scopeKey = normalizeCollectionHandle(getBrowseCollectionHandle(userContext));
      if (!productMatchesCollectionScope(product, scopeKey)) {
        return { product: product, score: -9999, reasons: ['Fuera de la categoría que estás explorando.'] };
      }
    }

    if (userContext.intent === 'gastronomia_bebidas' && !product.is_edible) {
      return { product: product, score: -9999, reasons: ['No apto para cocina o bebidas.'] };
    }

    if (hasMatch(product.intents, userContext.intent)) {
      score += 40;
      reasons.push(REASON_LABELS[userContext.benefit] || 'Alineado con tu intención.');
    }
    if (hasMatch(product.benefits, userContext.benefit)) {
      score += 25;
      reasons.push(REASON_LABELS[userContext.benefit] || 'Coincide con el beneficio que buscas.');
    }
    if (userContext.use_method && hasMatch(product.use_methods, userContext.use_method)) {
      score += 25;
      reasons.push(REASON_LABELS[userContext.use_method] || 'Compatible con tu forma de uso.');
    }

    var format = detectProductFormat(product);
    if (userContext.use_method && userContext.use_method !== 'no_seguro') {
      if (userContext.use_method === 'spray') {
        if (format === 'spray' || hasMatch(product.use_methods, 'spray')) {
          score += 35;
          reasons.push(REASON_LABELS.formato_spray);
        } else if (format === 'aceite_puro') {
          score -= 18;
        } else if (format === 'topico') {
          score -= 8;
        }
      } else if (userContext.use_method === 'difusor_aroma') {
        if (format === 'aceite_puro' || format === 'mezcla' || hasMatch(product.use_methods, 'difusor_aroma')) {
          score += 28;
          reasons.push(REASON_LABELS.formato_difusor);
        } else if (format === 'spray' && !hasMatch(product.use_methods, 'difusor_aroma')) {
          score -= 10;
        } else if (format === 'topico' || detectProductRole(product, format) === 'topico') {
          score -= 50;
        } else if (format === 'portador' || detectProductRole(product, format) === 'portador') {
          score -= 45;
        }
      } else if (userContext.use_method === 'piel_diluido') {
        if (format === 'topico' || format === 'kit' || hasMatch(product.use_methods, 'piel_diluido')) {
          score += 30;
          reasons.push(REASON_LABELS.formato_topico);
        } else if (format === 'aceite_puro') {
          score -= 12;
        }
      }
    }
    if (userContext.aroma && userContext.aroma !== 'sin_preferencia' && hasMatch(product.aromas, userContext.aroma)) {
      score += 15;
      reasons.push(REASON_LABELS[userContext.aroma] || 'Perfil aromático compatible.');
    }
    if (hasMatch(product.profiles, userContext.profile)) {
      score += 20;
    }
    if (hasMatch(product.roles, userContext.role)) {
      score += 20;
    }
    if (userContext.experience_level && hasMatch(product.experience_levels, userContext.experience_level)) {
      score += 10;
      reasons.push(REASON_LABELS.principiante);
    }

    if (product.is_kit && userContext.wants_kit) {
      score += 20;
      reasons.push(REASON_LABELS.kit);
    }
    if (product.is_edible && userContext.intent === 'gastronomia_bebidas') {
      score += 40;
      reasons.push(REASON_LABELS.comestible);
    }

    var isBeginner = userContext.experience_level === 'principiante';
    var isAdvancedOnly =
      product.experience_levels.length === 1 && product.experience_levels[0] === 'profesional';
    if (isBeginner && isAdvancedOnly) score -= 10;

    if (
      userContext.use_method === 'piel_diluido' &&
      hasMatch(product.use_methods, 'piel_diluido') &&
      !(product.safety_notes || '').toLowerCase().match(/dilu/)
    ) {
      score -= 20;
    } else if (userContext.use_method === 'piel_diluido' && (product.safety_notes || '').match(/dilu/i)) {
      reasons.push(REASON_LABELS.dilution);
    }

    score += Math.round((Math.min(100, Math.max(0, product.priority)) / 100) * 10);

    if (userContext.route && product.routes.length) {
      var routeKey = (userContext.route || '').replace(/^\/pages\//, '').replace(/-/g, '_');
      product.routes.forEach(function (r) {
        if (r === routeKey || userContext.route.indexOf(r) !== -1) score += 5;
      });
    }

    if (score <= 10 && product.tags && product.tags.length) {
      var tagsText = product.tags.join(' ').toLowerCase().replace(/_/g, ' ');
      [
        userContext.intent,
        userContext.benefit,
        userContext.profile,
        userContext.use_method,
        userContext.aroma,
        userContext.collection_handle
      ]
        .filter(Boolean)
        .forEach(function (token) {
          var needle = String(token).replace(/_/g, ' ').toLowerCase();
          if (needle && needle !== 'sin preferencia' && tagsText.indexOf(needle) !== -1) {
            score += 12;
            reasons.push('Relacionado con tu perfil.');
          }
        });
    }

    reasons = reasons.filter(function (r, i, a) { return a.indexOf(r) === i; }).slice(0, 4);
    if (!reasons.length) reasons.push('Seleccionado según tu perfil y preferencias.');

    var explanation = buildProductExplanation(product, userContext, format);

    return { product: product, score: score, reasons: reasons, explanation: explanation, format: format, role: detectProductRole(product, format) };
  }

  function enrichRanked(ranked, userContext, usedKeys) {
    usedKeys = usedKeys || {};
    return (ranked || []).map(function (row) {
      if (!row || !row.product) return row;
      var format = row.format || detectProductFormat(row.product);
      return {
        product: row.product,
        score: row.score,
        reasons: row.reasons || [],
        explanation: buildProductExplanation(row.product, userContext, format, usedKeys),
        format: format,
        role: row.role || detectProductRole(row.product, format)
      };
    });
  }

  function rankProducts(products, userContext) {
    return (products || [])
      .map(function (p) { return scoreProduct(p, userContext); })
      .filter(function (r) { return r.score > -1000; })
      .sort(function (a, b) { return b.score - a.score; });
  }

  function resolveResultsCount(options) {
    options = options || {};
    if (options.totalCount) return options.totalCount;
    if (options.resultsCount) return options.resultsCount;
    var primary = options.primaryCount;
    var complementary = options.complementaryCount;
    if (primary != null || complementary != null) {
      return (primary || 0) + (complementary != null ? complementary : 0);
    }
    return DEFAULT_RESULTS_COUNT;
  }

  function buildOutput(userContext, ranked, options) {
    options = options || {};
    var totalCount = resolveResultsCount(options);
    var role = userContext.role;
    var explanationUsedKeys = {};
    var qualified = ranked.filter(function (r) { return r.score >= MIN_SCORE_TO_SHOW; });
    if (!qualified.length) qualified = ranked.slice(0, totalCount);
    qualified = filterRankedByUseMethod(qualified, userContext);

    var products = diversifySelection(qualified, totalCount, userContext);
    var kitRec = ranked.find(function (r) { return r.product && r.product.is_kit; }) || null;

    var benefitLabel = BENEFIT_LABELS[userContext.benefit] || 'bienestar';
    var methodLabel = USE_METHOD_LABELS[userContext.use_method] || '';

    var headline = 'Tu selección recomendada';
    var intro =
      'Estas son las opciones que mejor encajan contigo según tu búsqueda de ' +
      benefitLabel +
      (methodLabel ? ' y tu preferencia de ' + methodLabel : '') +
      '.';
    if (userContext.use_method === 'difusor_aroma') {
      intro =
        'Estas son las opciones más aptas para difusor según tu búsqueda de ' +
        benefitLabel +
        '.';
    } else if (userContext.use_method === 'piel_diluido') {
      intro =
        'Estas son las opciones más aptas para uso tópico diluido según tu búsqueda de ' +
        benefitLabel +
        '.';
    } else if (userContext.use_method === 'spray') {
      intro =
        'Estas son las opciones más prácticas en spray según tu búsqueda de ' +
        benefitLabel +
        '.';
    }
    var browseCollection = getBrowseCollectionHandle(userContext);
    var cta = {
      label: browseCollection ? 'Ver más en esta categoría' : 'Explorar catálogo',
      url: browseCollection
        ? '/collections/' + encodeURIComponent(browseCollection)
        : userContext.route || '/collections/all'
    };

    var education = [];
    if (userContext.use_method === 'piel_diluido') {
      education.push({
        title: 'Uso responsable en piel',
        body: 'Los aceites esenciales deben usarse diluidos. Revisa la guía de cada producto antes de aplicar.'
      });
    }
    if (userContext.use_method === 'spray') {
      education.push({
        title: 'Un panorama, no un solo formato',
        body:
          'Mezclamos sprays listos para usar, aceites puros versátiles y kits completos. Así puedes comparar opciones reales según cómo prefieras vivir tu objetivo.'
      });
    }
    if (userContext.use_method === 'difusor_aroma') {
      education.push({
        title: 'Para difusor y ambiente',
        body:
          'Los aceites puros y mezclas suelen ser la opción más directa en difusor. Los sprays pueden complementar el ambiente de otra forma.'
      });
    }
    if (role === 'prescriptor') {
      headline = 'Recursos para uso profesional';
      intro =
        'Priorizamos guías y orientación de uso responsable para acompañar a tus pacientes o clientes.';
      cta = { label: 'Ver guías de uso profesional', url: userContext.route };
      products = ranked.filter(function (r) {
        return (r.product.safety_notes || '').length > 20;
      }).slice(0, totalCount);
      if (!products.length) products = qualified.slice(0, Math.min(2, totalCount));
    }
    if (role === 'distribuidor') {
      headline = 'Programa y catálogo Oleum Vitae';
      intro = 'Te conectamos con información comercial y opciones para distribución.';
      cta = {
        label: 'Conocer programa de distribución',
        url: userContext.route || '/pages/distribuidores'
      };
      products = [];
    }

    var scopeKeyForKit = normalizeCollectionHandle(getBrowseCollectionHandle(userContext));
    var scopeAllowsKit =
      !scopeKeyForKit ||
      !COLLECTION_SCOPE_BY_HANDLE[scopeKeyForKit] ||
      !COLLECTION_SCOPE_BY_HANDLE[scopeKeyForKit].denyKinds ||
      COLLECTION_SCOPE_BY_HANDLE[scopeKeyForKit].denyKinds.indexOf('kit_aceites') === -1;

    if (
      scopeAllowsKit &&
      isBeginnerContext(userContext) &&
      kitRec &&
      !products.some(function (p) {
        return p.product.is_kit;
      })
    ) {
      products = [kitRec]
        .concat(products.filter(function (p) { return p.product.id !== kitRec.product.id; }))
        .slice(0, totalCount);
    }

    if (!products.length && qualified.length && role !== 'distribuidor') {
      products = diversifySelection(qualified, totalCount, userContext);
    }

    products = enrichRanked(products, userContext, explanationUsedKeys);

    return {
      context: userContext,
      route: userContext.route,
      headline: headline,
      intro: intro,
      products: products,
      primary_products: products,
      complementary_products: [],
      kit_recommendation: kitRec,
      education_blocks: education,
      cta: cta,
      recommended_product_ids: products.map(function (r) { return r.product.id; }).filter(Boolean)
    };
  }

  function isBeginnerContext(ctx) {
    return ctx.experience_level === 'principiante' || (ctx.tags || []).indexOf('guia_simple') !== -1;
  }

  function getRecommendations(products, userContext, options) {
    options = options || {};
    var ctx = userContext || {};
    var ranked = rankProducts(products, ctx);

    if (!ranked.length && shouldApplyCollectionScope(ctx)) {
      ctx = Object.assign({}, ctx, { browse_collection: '' });
      ranked = rankProducts(products, ctx);
    }

    return buildOutput(ctx, ranked, options);
  }

  function runSelfTests(catalog) {
    catalog = catalog || [];
    var Engine = global.OleumProfileEngine;
    if (!Engine) {
      console.warn('OleumProfileEngine requerido para tests');
      return false;
    }
    var ctx = Engine.buildUserContext({
      primary_use: 'cocina_bebidas',
      preparacion: 'mixologia',
      perfil_sabor: 'citrico',
      experience: 'intermedio',
      benefit: 'bienestar_general'
    });
    var ranked = rankProducts(catalog, ctx);
    var nonEdible = ranked.filter(function (r) { return r.product && !r.product.is_edible; });
    console.log('Recommender cocina: excluidos no comestibles en top', nonEdible.length === 0 || nonEdible[0].score < 0);
    console.log('Top 3 scores:', ranked.slice(0, 3).map(function (r) { return r.product.title + ':' + r.score; }));
    return true;
  }

  global.OleumRecommender = {
    normalizeProduct: normalizeProduct,
    scoreProduct: scoreProduct,
    rankProducts: rankProducts,
    getRecommendations: getRecommendations,
    runSelfTests: runSelfTests
  };
})(typeof window !== 'undefined' ? window : globalThis);
